export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-live-line text-2xl text-primary-500"></i>
                </span>
                <span className="text-lg font-heading text-foreground-900">
                  每日大赛入口
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                每日大赛入口致力于为全球赛事爱好者提供高清流畅的每日大赛在线观看服务，涵盖每日大赛免费观看、每日大赛视频及每日大赛全集等丰富内容。作为领先的每日大赛平台，我们每日更新最新最全的每日大赛最新视频资源，让您随时随地畅享精彩竞技盛宴。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
              <div className="grid grid-cols-2 gap-2">
                <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">热门话题</a>
                <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">精选推荐</a>
                <a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">热门榜单</a>
                <a href="#carousel" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
                <a href="#features" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">平台特色</a>
                <a href="#updates" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">最新动态</a>
                <a href="#media" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">精彩视频</a>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
                <a href="#about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
                <a href="#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-500">合作伙伴信息持续更新中，敬请期待。</p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 每日大赛入口 - 每日大赛入口在线观看 | 每日大赛免费观看视频与全集
            </p>
            <p className="text-xs text-foreground-500">
              每日更新 · 高清流畅 · 完全免费
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}